import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { spacing } from '../constants/spacing.js';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';
import { breakpoints } from '../constants/breakpoints.js';

var GRID_MAX_WIDTH = px2rem(breakpoints.xl);
var getGridPadding = function getGridPadding(breakpoint) {
  switch (breakpoint) {
    case 'xxs':
      return spacing.xxs;
    case 'xs':
      return spacing.xs;
    case 's':
      return spacing.s;
    case 'm':
      return spacing.xl;
    case 'l':
      return spacing.xxl;
    case 'xl':
      return spacing.xxl;
    case 'xxl':
      return 0;
  }
};
var getBreakpointOffset = function getBreakpointOffset(breakpoint, offsets
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
) {
  return offsets && offsets[breakpoint] ? offsets[breakpoint] : 0;
};
var breakpointWithOffset = function breakpointWithOffset(breakpoint) {
  return function (props) {
    return "@media(min-width: ".concat(breakpoints[breakpoint] + 1 + getBreakpointOffset(breakpoint, props.offsets), "px)");
  };
};
var gridStyles = /*#__PURE__*/css(["box-sizing:border-box;margin:0 auto;text-align:inherit;width:100%;", " ", "{max-width:", ";}"], function (props) {
  return !props.$disablePadding && css(["padding:0 ", ";", "{padding:0 ", ";}", "{padding:0 ", ";}", "{padding:0 ", ";}", "{padding:0 ", ";}", "{padding:0 ", ";}", "{padding:0 ", ";}"], getGridPadding('xxs'), breakpointWithOffset('xs'), getGridPadding('xs'), breakpointWithOffset('s'), getGridPadding('s'), breakpointWithOffset('m'), getGridPadding('m'), breakpointWithOffset('l'), getGridPadding('l'), breakpointWithOffset('xl'), getGridPadding('xl'), breakpointWithOffset('xxl'), getGridPadding('xxl'));
}, breakpointWithOffset('xxl'), GRID_MAX_WIDTH);
var grid = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !(prop === 'offsets' || boxPropExclusions.has(prop));
  }
}).withConfig({
  displayName: "styles__grid",
  componentId: "sc-1b9tk6e-0"
})(["", " ", ""], gridStyles, boxStyles);

export { GRID_MAX_WIDTH, breakpointWithOffset, getGridPadding, grid, gridStyles };
